import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import Btn from "components/Custom/Btn";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import TxtRow from "components/Custom/TxtRow";
import UiDialog from "components/Custom/UiDialog";
import { COMMON_JS } from "common/scripts";
import { DEFAULTS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import {
  ERRORS,
  LABELS,
  SUB_TITLES,
  SUCCESS,
  TITLES,
  WARNINGS,
} from "common/lables";
import AutoComplete from "components/Custom/AutoComplete";
import { MASTER_APIs } from "apihandlers/master";
import { DateFunctions } from "common/datefunctions";

import { USER_APIs } from "apihandlers/user";
import { GEO_APIs } from "apihandlers/geography";

const AssetAudit = (props: any) => {
  const { setDashMenu } = props;

  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [gridLoading, setGridLoading] = useState(true);

  const [isSubmit, setIsSubmit] = useState(false);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const [mandatoryLoadResults, setMandatoryLoadResults] = useState<any[]>([]);
  const [asset, setAsset] = useState([]);
  const [users, setUsers] = useState([]);
  const [editData, setEditData] = useState<boolean>(false);
  const [remarksRow, setRemarksRow] = useState<any>(
    selectedRow.messages ? selectedRow.messages : []
  );
  const [district, setDistrict] = useState([]);
  const [cities, setCities] = useState([]);

  const usersRef: any = useRef(null);
  const districtRef: any = useRef(null);
  const remarksGridRef: any = useRef(null);
  const citiesRef: any = useRef(null);

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "asset",
      name: LABELS.ASSET,
      width: "30%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "auditedBy",
      name: LABELS.AUDITED_BY,
      width: "30%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },
    {
      key: "auditedOn",
      name: LABELS.AUDITED_ON,
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
      type: "text",
      searchable: true,
    },

    {
      key: "activeStatus",
      name: LABELS.ACTIVE,
      width: "10%",
      editable: false,
      sortable: true,
      align: "center",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      searchable: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const remarksColumn = [
    {
      key: "asset",
      name: LABELS.ASSET,
      width: "50%",
      type: "dropdown",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
      list: asset,
    },
    {
      key: "remarks",
      name: LABELS.REMARKS,
      width: "50%",
      type: "text",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: false,
      searchable: false,
    },
  ];

  useEffect(() => {
    if (loading) {
    }
    getDistrict();
  }, [loading]);

  const getDistrict = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    GEO_APIs.getDistricts(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.districtName,
          };
        });
        setDistrict(list);
        getUsers();
      }
    });
  };

  const getCities = async (districtId) => {
    let cityList = [];
    try {
      const args = {
        districtId,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getCities(args);
      cityList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.cityName,
        };
      });
    } catch (error) {}
    return cityList;
  };

  const getUsers = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    USER_APIs.getUsers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setUsers(list);
        getAsset();
      }
    });
  };

  const getAsset = () => {
    const args = {
      activeStatus: true,
      minResponse: true,
    };
    MASTER_APIs.getAsset(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.assetName,
          };
        });
        setAsset(list);
      }
    });
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
    setEditData(false);
    setRemarksRow([]);
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setEditData(true);
    setManageDialog(true);
    setRemarksRow(JSON.parse(row.remarks));
  };

  const reloadGrid = () => {
    setRows(null);
    loadGrid();
  };

  const loadGrid = () => {
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    let loadErrors = [];

    if (fromDt === "") {
      loadErrors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt === "") {
      loadErrors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }

    setGridLoading(false);
    setMandatoryLoadResults(loadErrors);
    if (loadErrors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    const args = {
      fromDt,
      toDt,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    setGridLoading(false);
    MASTER_APIs.getAssetAudit(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(true);
      }
    });
  };

  const manageRecord = () => {
    // const assetId = customerRef.current.selectedValue.id;
    const auditedBy = usersRef.current.selectedValue.id;
    const cityId = citiesRef.current.selectedValue.id;
    let ele = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = ele ? ele.value : "";
    //todo:Validations needs to be done

    // Validations;
    let errors = [];
    // if (!vehicleId) {
    //   errors.push({
    //     id: "vehicleId",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.VEHICLE +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (detail === "") {
    //   errors.push({
    //     id: "detail",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.DETAILS +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (entryDate === "") {
    //   errors.push({
    //     id: "entryDate",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.ENTRY_DATE +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // setMandatoryResults(errors);
    // if (errors.length > 0) {
    //   COMMON_JS.showNotify(
    //     props,
    //     NOTIFY.WARNING,
    //     WARNINGS.PLEASE_CHECK_FORM_ERRORS
    //   );
    //   return;
    // }

    const args = {
      id: selectedRow.id || -1,
      // assetId,
      cityId,
      auditedBy,
      remarks: remarksGridRef.getRowData(),
      activeStatus,
    };
    console.log("args", args);
    setIsSubmit(true);
    MASTER_APIs.manageAssetAudit(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const getDeaultRemarksRow = () => {
    const newRow: any = {
      id: "1." + (remarksGridRef.getRowData().length + 1).toString(),
    };
    return newRow;
  };

  const handleDistrictChange = async (e, f) => {
    if (f.id) {
      const res = await getCities(f.id);
      setCities(res);
    }
  };
  console.log("Page: AssetAudit:");

  return (
    loading && (
      <React.Fragment>
        <div className="pageInfo">
          <ul className="breadcrumbs">
            <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
            <li className="dim">{" / "}</li>
            <li onClick={() => setDashMenu(LABELS.HOME)}>
              {LABELS.TRANSACTION}{" "}
            </li>
            <li className="dim">{" / "}</li>
            <li className="active">{TITLES.ASSET_AUDIT}</li>
          </ul>
          <h4>{TITLES.ASSET_AUDIT}</h4>
          <p>{SUB_TITLES.ASSET_AUDIT}</p>
        </div>
        <div
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          <div
            className="formGroup"
            style={{
              display: "flex",
              flexDirection: "row",
              marginTop: 0,
              marginBottom: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                marginRight: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  fontWeight: "500",
                  fontSize: 14,
                  marginTop: 6,
                  marginRight: 8,
                }}
              >
                {LABELS.FROM_DATE}
              </label>
              <TxtRow
                type={"date"}
                id="fromDt"
                defaultValue={DateFunctions.getDate(
                  "today",
                  "from",
                  "YYYY-MM-DD"
                )}
              />
            </div>

            <div
              style={{
                display: "flex",
                marginRight: 15,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <label
                style={{
                  fontWeight: "500",
                  fontSize: 14,
                  marginTop: 6,
                  marginRight: 8,
                }}
              >
                {LABELS.TO_DATE}
              </label>
              <TxtRow
                type={"date"}
                id="toDt"
                defaultValue={DateFunctions.getDate(
                  "thismonth",
                  "to",
                  "YYYY-MM-DD"
                )}
              />
            </div>

            <div
              style={{
                display: "flex",
                padding: 10,
                marginTop: "0.3rem",
              }}
            >
              <Btn
                text={LABELS.LOAD}
                onClick={loadGrid}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </div>
        {mandatoryLoadResults.length > 0 && (
          <div className="mandatoryBox">
            <ul>
              {mandatoryLoadResults.map((m) => {
                return (
                  <li>
                    <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                  </li>
                );
              })}
            </ul>
          </div>
        )}
        <div className="grid excelGridWrapper">
          {!gridLoading &&
            (rows ? (
              <ExcelGrid
                id={"assetAudit"}
                height={window.innerHeight * 0.8}
                cols={columns}
                rows={rows}
                exportOption={true}
                newRowOption={false}
                exportName={LABELS.ASSET_AUDIT}
                onReload={reloadGrid}
                onAdd={onAdd}
              />
            ) : (
              <div className="flexRowCenter">
                <Loader />
              </div>
            ))}
        </div>

        {manageDialog && (
          <UiDialog
            title={
              selectedRow.id
                ? "Edit " + TITLES.ASSET_AUDIT + ": " + selectedRow.asset
                : "Add " + TITLES.ASSET_AUDIT
            }
            open={true}
            size={"sm"}
            onClose={() => {
              setManageDialog(false);
              setMandatoryResults([]);
            }}
          >
            <div className="flexColumn">
              {/* <div className="formGroup  ">
                <label>{LABELS.LOCATION}</label>
                <AutoComplete
                  list={area}
                  childRef={areaRef}
                  defaultValue={
                    selectedRow.assetId
                      ? {
                          id: selectedRow.assetId,
                          label: selectedRow.asset,
                        }
                      : null
                  }
                  disabled={isSubmit}
                />
              </div> */}
              <div className="formGroup  ">
                <label>{LABELS.DISTRICT}</label>
                <AutoComplete
                  list={district}
                  childRef={districtRef}
                  defaultValue={
                    selectedRow.districtId
                      ? {
                          id: selectedRow.districtId,
                          label: selectedRow.districtName,
                        }
                      : null
                  }
                  onChange={handleDistrictChange}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup  ">
                <label>{LABELS.CITY}</label>
                <AutoComplete
                  list={cities}
                  childRef={citiesRef}
                  defaultValue={
                    selectedRow.cityId
                      ? {
                          id: selectedRow.cityId,
                          label: selectedRow.cityName,
                        }
                      : null
                  }
                  // onChange={handleAreaChange}
                  disabled={isSubmit}
                />
              </div>
              <div className="formGroup  ">
                <label>{LABELS.AUDITED_BY}</label>
                <AutoComplete
                  list={users}
                  childRef={usersRef}
                  defaultValue={
                    selectedRow.assetId
                      ? {
                          id: selectedRow.assetId,
                          label: selectedRow.asset,
                        }
                      : null
                  }
                  onChange={(e, v) => {}}
                  disabled={isSubmit}
                />
              </div>
              <div
                className="grid"
                style={{
                  width: "100%",
                  height: "80%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <ExcelGrid
                  id={"remarks"}
                  height={600}
                  childRef={remarksGridRef}
                  cols={remarksColumn}
                  rows={remarksRow}
                  exportOption={false}
                  newRowOption={false}
                  getDefaultNewRow={getDeaultRemarksRow}
                />
              </div>

              {/* mandatoryResults */}
              {mandatoryResults.length > 0 && (
                <div className="mandatoryBox">
                  <ul>
                    {mandatoryResults.map((m) => {
                      return (
                        <li>
                          <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
              <div className="formGroup submitBtnWrapper">
                <div className="flexbtnjustify">
                  <Btn
                    text={LABELS.CANCEL}
                    bgColor={COLORS.RELOAD_EXPORT}
                    color={COLORS.RELOAD_EXPORT_TEXT}
                    onClick={() => {
                      setManageDialog(false);
                      setMandatoryResults([]);
                    }}
                    loading={isSubmit}
                  />
                  <Btn
                    text={LABELS.SAVE}
                    onClick={manageRecord}
                    loading={isSubmit}
                    bgColor={COLORS.SAVE_GREEN}
                  />
                </div>
              </div>
            </div>
          </UiDialog>
        )}
      </React.Fragment>
    )
  );
};
export default withSnackbar(AssetAudit);
